import TUICallEngine, { TUICallEvent } from '@trtc/call-engine-lite-js'
import { getTIM } from './timHelper'

let tuicall = null

/** 初始化引擎（复用已有的 TIM 实例） */
export async function initTUICallEngine(sdkAppId, userId, userSig) {
  const tim = getTIM()
  if (!tim) throw new Error('TIM 未初始化，请先 loginTIM')

  console.log('[TUICallEngine] 开始创建实例，sdkAppId:', sdkAppId, 'userId:', userId)

  tuicall = TUICallEngine.createInstance({
    sdkAppID: Number(sdkAppId),
    tim
  })

  console.log('[TUICallEngine] 实例创建成功，准备 login...')

  await tuicall.login({
    userID: String(userId),
    userSig
  })

  console.log('[TUICallEngine] login 成功')

  tuicall.on(TUICallEvent.ERROR, (err) => {
    console.error('[TUICallEngine] ERROR 事件:', err)
  })

  tuicall.on(TUICallEvent.SDK_READY, () => {
    console.log('[TUICallEngine] SDK_READY 引擎已就绪')
  })

  return tuicall
}

export function getTUICallEngine() {
  return tuicall
}

export function destroyTUICallEngine() {
  try {
    TUICallEngine.destroyInstance()
  } catch (e) {
    tuicall?.destroyInstance?.()
  }
  tuicall = null
}

/** 监听来电 */
export function onIncomingCall(callback) {
  if (!tuicall) {
    console.warn('[TUICallEngine] onIncomingCall 失败：tuicall 实例为 null')
    return
  }
  tuicall.on(TUICallEvent.ON_CALL_RECEIVED, (event) => {
    console.log('[TUICallEngine] 触发 ON_CALL_RECEIVED:', event)
    callback(event)
  })
  if (TUICallEvent.INVITED) {
    tuicall.on(TUICallEvent.INVITED, (event) => {
      console.log('[TUICallEngine] 触发 INVITED（旧版兼容）:', event)
      callback(event)
    })
  }
  console.log('[TUICallEngine] 来电监听已注册')
}

/** 监听通话接通（双方进入房间） */
export function onCallConnected(callback) {
  if (!tuicall) return
  const eventName = TUICallEvent.ON_CALL_CONNECTED || TUICallEvent.CALLING_START
  tuicall.on(eventName, (event) => {
    console.log('[TUICallEngine] 通话接通事件:', event)
    callback(event)
  })
}

/** 监听对方视频可用 */
export function onUserVideoAvailable(callback) {
  tuicall?.on(TUICallEvent.USER_VIDEO_AVAILABLE, (event) => {
    console.log('[TUICallEngine] USER_VIDEO_AVAILABLE:', event)
    callback(event)
  })
}

/** 监听通话结束 */
export function onCallEnd(callback) {
  if (!tuicall) return
  const endEvent = TUICallEvent.ON_CALL_END || TUICallEvent.CALLING_END
  tuicall.on(endEvent, (event) => {
    console.log('[TUICallEngine] 通话结束事件:', event)
    callback(event)
  })
}

/** 接听 */
export function acceptCall() {
  console.log('[TUICallEngine] 执行 accept')
  return tuicall?.accept()
}

/** 拒绝 */
export function rejectCall() {
  console.log('[TUICallEngine] 执行 reject')
  return tuicall?.reject()
}

/** 挂断 */
export function hangupCall() {
  console.log('[TUICallEngine] 执行 hangup')
  return tuicall?.hangup()
}

/** 启动本地摄像头（传 DOM id 字符串） */
export function openCamera(videoViewDomID) {
  console.log('[TUICallEngine] openCamera:', videoViewDomID)
  return tuicall?.openCamera(String(videoViewDomID))
}

export function closeCamera() {
  return tuicall?.closeCamera?.() || tuicall?.closeCamara?.()
}

export function openMicrophone() {
  return tuicall?.openMicrophone()
}

export function closeMicrophone() {
  return tuicall?.closeMicrophone()
}

/** 订阅远端视频：兼容新版引擎多种参数格式 */
export function startRemoteView(userId, videoViewDomID) {
  console.log('[TUICallEngine] startRemoteView:', userId, videoViewDomID)
  const dom = document.getElementById(videoViewDomID)
  console.log('[TUICallEngine] DOM元素:', dom)

  // 方式1：对象参数（新版 @trtc/call-engine-lite-js 可能采用）
  try {
    const result = tuicall?.startRemoteView({
      userID: String(userId),
      videoViewDomID: String(videoViewDomID)
    })
    console.log('[TUICallEngine] 方式1（对象参数）调用成功')
    return result
  } catch (e) {
    console.warn('[TUICallEngine] 方式1失败:', e)
  }

  // 方式2：DOM 元素作为第二参数
  try {
    const result = tuicall?.startRemoteView(String(userId), dom)
    console.log('[TUICallEngine] 方式2（DOM对象）调用成功')
    return result
  } catch (e) {
    console.warn('[TUICallEngine] 方式2失败:', e)
  }

  // 方式3：标准字符串参数（旧版兼容）
  try {
    const result = tuicall?.startRemoteView(String(userId), String(videoViewDomID))
    console.log('[TUICallEngine] 方式3（字符串参数）调用成功')
    return result
  } catch (e) {
    console.warn('[TUICallEngine] 方式3失败:', e)
    throw e
  }
}

export function stopRemoteView(userId) {
  return tuicall?.stopRemoteView(String(userId))
}
